<template>
  <div class="app">
    <div v-if="isMobile" class="mobile-overlay">
      <div class="mobile-overlay-content">
        <div class="mobile-icon">🖥</div>
        <h2>请在 PC 端打开</h2>
        <p>本系统为数据可视化大屏，仅支持 PC 端访问</p>
      </div>
    </div>
    <router-view v-else/>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const MOBILE_BREAKPOINT = 768
const isMobile = ref(window.innerWidth < MOBILE_BREAKPOINT)

const checkScreen = () => {
  isMobile.value = window.innerWidth < MOBILE_BREAKPOINT
}

onMounted(() => window.addEventListener('resize', checkScreen))
onUnmounted(() => window.removeEventListener('resize', checkScreen))
</script>

<style>
* { margin: 0; padding: 0; box-sizing: border-box; }

.app { width: 100%; height: 100vh; }

.mobile-overlay {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0f0f23;
}

.mobile-overlay-content {
  text-align: center;
  color: #fff;
  padding: 40px;
}

.mobile-icon { font-size: 64px; margin-bottom: 24px; }

.mobile-overlay-content h2 {
  font-size: 24px;
  margin-bottom: 12px;
  color: #e0e0ff;
}

.mobile-overlay-content p {
  font-size: 14px;
  color: #888;
  line-height: 1.6;
}
</style>
